var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.059,
    height: 17.062,
    viewBox: "0 0 17.059 17.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warehouse",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M16.351,4.92H7.212L5.08,7.966h13.4Z",
    transform: "translate(-0.751 -0.64)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M15.437,21.622v2.608A4.265,4.265,0,0,0,16.549,27.1H5.08V14.92h13.4v5.788Z",
    transform: "translate(-0.751 -7.594)",
    fill: "#d3d2d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 3.046,
    height: 2.437,
    transform: "translate(9.508 7.326)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M22.08,7.966h3.046L24.517,4.92H22.689Z",
    transform: "translate(-12.572 -0.64)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M12.822,46.052H10.385a.3.3,0,0,1,0-.609h2.437a.3.3,0,0,1,0,.609Zm0-1.523H10.385a.3.3,0,1,1,0-.609h2.437a.3.3,0,1,1,0,.609Z",
    transform: "translate(-4.228 -27.76)",
    fill: "#3aa3cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M45.172,34.834v2.608a4.265,4.265,0,0,1-3.046,4.094,4.265,4.265,0,0,1-3.046-4.094V34.834l3.046-.914Z",
    transform: "translate(-24.394 -20.806)",
    fill: "#baff29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M17.129,18.293a.3.3,0,0,1-.213-.091L16,17.288a.3.3,0,0,1,.43-.43l.7.7,1.919-1.916a.3.3,0,0,1,.43.43L17.345,18.2A.3.3,0,0,1,17.129,18.293Zm.585-10.637H4.31a.3.3,0,0,1-.25-.469L6.193,4.14A.3.3,0,0,1,6.443,4h9.139a.3.3,0,0,1,.25.131l2.132,3.046a.307.307,0,0,1-.25.478ZM4.9,7.046H17.129L15.423,4.609H6.589Z",
    transform: "translate(-0.006 0)",
    fill: "#542020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M24.351,17.046H21.3a.3.3,0,0,1-.3-.3V14.3a.3.3,0,0,1,.3-.3h3.046a.3.3,0,0,1,.3.3v2.437A.3.3,0,0,1,24.351,17.046Zm-2.742-.609h2.437V14.609H21.609Z",
    transform: "translate(-11.821 -6.954)",
    fill: "#542020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M24.34,7.655H21.294a.316.316,0,0,1-.3-.366L21.6,4.244A.3.3,0,0,1,21.9,4h1.828a.3.3,0,0,1,.3.244l.609,3.046a.307.307,0,0,1-.3.366Zm-2.675-.609h2.3l-.487-2.437H22.153Z",
    transform: "translate(-11.811 0)",
    fill: "#542020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M12.742,46.132H10.3a.3.3,0,1,1,0-.609h2.437a.3.3,0,1,1,0,.609Zm0-1.523H10.3a.3.3,0,1,1,0-.609h2.437a.3.3,0,1,1,0,.609Z",
    transform: "translate(-4.172 -27.815)",
    fill: "#baff29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M15.774,26.794H4.3a.3.3,0,0,1-.3-.3V14.3a.3.3,0,0,1,.3-.3h13.4a.3.3,0,0,1,.3.3v5.788a.3.3,0,0,1-.216.3l-2.83.835v2.382A3.96,3.96,0,0,0,16,26.285a.3.3,0,0,1-.225.509ZM4.609,26.185H15.146a4.569,4.569,0,0,1-.789-2.571V21.006a.3.3,0,0,1,.216-.3l2.83-.835V14.609H4.609Z",
    transform: "translate(0 -6.954)",
    fill: "#542020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M41.35,41.2a.3.3,0,0,1-.088,0A4.569,4.569,0,0,1,38,36.8V34.192a.3.3,0,0,1,.216-.3l3.046-.914a.347.347,0,0,1,.177,0l3.046.914a.3.3,0,0,1,.216.3V36.8a4.569,4.569,0,0,1-3.263,4.4A.3.3,0,0,1,41.35,41.2Zm-2.742-6.781V36.8a3.96,3.96,0,0,0,2.742,3.789,3.942,3.942,0,0,0,2.742-3.774v-2.4l-2.742-.835Z",
    transform: "translate(-23.642 -20.14)",
    fill: "#542020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M44.216,44.739A.3.3,0,0,1,44,44.65l-.914-.914a.306.306,0,0,1,.433-.433l.7.7,1.916-1.919a.306.306,0,0,1,.433.433L44.432,44.65A.3.3,0,0,1,44.216,44.739Z",
    transform: "translate(-27.117 -26.422)",
    fill: "#1a1b41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.02d5f1a30731dacc8ff689de63ac3529.svg";
export { ForwardRef as ReactComponent };